module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowLineThickRight_white.766735c6.svg";